import React, { useState, useEffect } from "react";
import brands1 from "../assets/images/brands1.jpg";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.svg";
import MotevafaImg from "../assets/images/motevafa.jpg";
import Footer from "./Footer";
import TopNav from "./TopNav";

import sia from "../services/Api";
import { data } from "jquery";

const citySingle = (props) => {
  const [cityDead, setCityDead] = useState([]);
  const [cityName, setCityName] = useState(null);
  const [search, setSearch] = useState('');

  useEffect(() => {

    const search = props.location.search
    const params = new URLSearchParams(search)
    const city_en = params.get('enName')
    setCityName(params.get('name'))

    const cityData = {
      params: {
        nameEn: city_en,
      },
    };

    const data = {
      params: {
        city_nameEn: city_en,
        unConfirm: 1,
      },
    };

    sia
      .getDataFromServer("/dead", data)
      .then((res) => {
        setCityDead(res.data);
        // console.log(res);
      })
      .catch((err) => {
      });

  }, []);
  return (
    <>
      <header>
        <div className="pagewrapper slim1" id="header-slim">
          <div className="container">
            <TopNav />
          </div>
        </div>
      </header>
      <div className="clear" />
      <div className="pagewrapper" id="center-search">
        <div className="container">
          <form onSubmit={() => window.location.assign('/d-list?s=' + search)} action id="center-search-form" method="get">
            <input
              type="text"
              name="s"
              placeholder="کد متوفی را جستجو کنید"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="text radius50 box-sizing"
            />
            <input type="submit" value="جستجو" className="btn ease radius50" />
          </form>
          <a href="#" title className="link-btn ease box-sizing radius50">
            {localStorage.getItem('token') ? 'ثبت یادبود' : 'ورود و ثبت نام رایگان صفحه یادبود'}
          </a>
        </div>
      </div>
      <div className="pagewrapper" id="motevafa-list">
        <div className="container">
          <h2 className="main-title">شهر {cityName}</h2>
          <ul className="list-items people">
            {cityDead.map((item) => (
              <li key={item._id} className="item">
                <Link
                  className="ease box-sizing radius10"
                  to={`/motevafa/` + item._id}
                >
                  <img
                    src={
                      "https://nekooyad.com/proc/public/Images/" +
                      item.picture
                    }
                    alt=""
                    class="radius10"
                    width="40"
                    height="40"
                  />

                  <span>{item.name} ({item.record_id})</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="clear" />
      <Footer />
    </>
  );
};

export default citySingle;
